/**
 * Application version - synced with backend/app/version.py
 * Format: YY.M.patch (e.g., 26.1.1)
 *
 * Version scheme:
 * - YY: 2-digit year (26 = 2026)
 * - M: Month (1-12, no leading zero)
 * - .patch: Patch number, resets each month
 *
 * Updated by: version-release skill
 */
export const VERSION = '26.6.1'
